const CHATWOOT_DOMAIN_PATTERN = /(?:https?:\/\/)?(?:www\.)?chatwoot\.com/gi;
const APP_CHATWOOT_HOST_PATTERN = /app\.chatwoot\.com/gi;
const CHWT_APP_PATTERN = /https?:\/\/(?:www\.)?chwt\.app/i;

const parseHostname = url => {
  if (!url) return null;
  try {
    return new URL(url).host;
  } catch {
    return null;
  }
};

export const mergeUrlBase = (base, sourceUrl) => {
  if (!base || !sourceUrl) return base || sourceUrl;

  try {
    const source = new URL(sourceUrl);
    const baseUrl = new URL(base);
    const basePath = baseUrl.pathname.replace(/\/$/, '');
    return `${baseUrl.origin}${basePath}${source.pathname}${source.search}${source.hash}`;
  } catch {
    return base;
  }
};

export const getBrandingConfigFromWindow = () => {
  const config = window.globalConfig || {};
  return {
    installationName: config.INSTALLATION_NAME,
    brandName: config.BRAND_NAME,
    termsURL: config.TERMS_URL,
    privacyURL: config.PRIVACY_URL,
    brandURL: config.BRAND_URL,
    widgetBrandURL: config.WIDGET_BRAND_URL,
    helpURL: config.HELP_URL,
    docsURL: config.DOCS_URL,
    hostURL: window.chatwootConfig?.hostURL,
    helpCenterURL: window.chatwootConfig?.helpCenterURL,
  };
};

export const brandingDisplayName = (config = getBrandingConfigFromWindow()) => {
  const { installationName, brandName } = config;
  if (installationName && installationName !== 'Chatwoot') {
    return installationName;
  }
  if (brandName && brandName !== 'Chatwoot') {
    return brandName;
  }
  return null;
};

export const applyBrandingToUrl = (
  url,
  config = getBrandingConfigFromWindow()
) => {
  if (!url || typeof url !== 'string') return url;

  let result = url;
  const { helpURL, docsURL, brandURL, termsURL, privacyURL } = config;

  const helpBase = helpURL || brandURL;
  if (helpBase && CHWT_APP_PATTERN.test(result)) {
    result = mergeUrlBase(helpBase, result);
  }

  if (helpBase && /https?:\/\/(?:www\.)?chatwoot\.com\/hc/i.test(result)) {
    result = mergeUrlBase(helpBase, result);
  }

  const docsBase = docsURL || brandURL;
  if (docsBase && /https?:\/\/(?:www\.)?chatwoot\.com\/docs/i.test(result)) {
    result = mergeUrlBase(docsBase, result);
  }

  if (
    brandURL &&
    /https?:\/\/(?:www\.)?chatwoot\.com\/changelog/i.test(result)
  ) {
    result = `${brandURL.replace(/\/$/, '')}/changelog/`;
  }

  if (brandURL && /https?:\/\/(?:www\.)?chatwoot\.com\/blog\//i.test(result)) {
    const slug = result.match(/\/blog\/([^/?#]+)/i)?.[1];
    result = slug
      ? `${brandURL.replace(/\/$/, '')}/blog/${slug}`
      : `${brandURL.replace(/\/$/, '')}/blog/`;
  }

  if (termsURL) {
    result = result.replace(
      /https?:\/\/(?:www\.)?chatwoot\.com\/terms(?:-of-service)?/gi,
      termsURL
    );
  }

  if (privacyURL) {
    result = result.replace(
      /https?:\/\/(?:www\.)?chatwoot\.com\/privacy-policy/gi,
      privacyURL
    );
  }

  const replacementHost =
    parseHostname(brandURL) ||
    parseHostname(config.hostURL) ||
    parseHostname(termsURL);

  if (replacementHost) {
    result = result.replace(APP_CHATWOOT_HOST_PATTERN, replacementHost);
  }

  if (brandURL) {
    const normalizedBrandUrl = brandURL.replace(/\/$/, '');
    result = result.replace(CHATWOOT_DOMAIN_PATTERN, normalizedBrandUrl);
  }

  return result;
};

export const applyBrandingToText = (
  text,
  config = getBrandingConfigFromWindow()
) => {
  if (!text || typeof text !== 'string') return text;

  let result = text;
  const displayName = brandingDisplayName(config);

  if (displayName) {
    result = result.replace(/Chatwoot/g, displayName);
  }

  const urlPattern = /https?:\/\/[^\s"'<>]+/gi;
  result = result.replace(urlPattern, matchedUrl =>
    applyBrandingToUrl(matchedUrl, config)
  );

  const { brandURL, hostURL, termsURL } = config;
  const replacementHost =
    parseHostname(brandURL) ||
    parseHostname(hostURL) ||
    parseHostname(termsURL);

  if (replacementHost) {
    result = result.replace(APP_CHATWOOT_HOST_PATTERN, replacementHost);
  }

  if (brandURL) {
    const normalizedBrandUrl = brandURL.replace(/\/$/, '');
    result = result.replace(CHATWOOT_DOMAIN_PATTERN, normalizedBrandUrl);
  }

  return result;
};
